// Task 24882 - "is this button supposed to show the calendar / this button
// doesnt do anything when clicked".
//
// The blue button on the end of a date-range filter has two states. When a
// range IS set it shows a cross that clears it, and that has always worked.
// When no range is set it shows a calendar icon - and that icon had no handler
// at all, on any screen. The CSS gives the button `cursor: pointer`, so it has
// always looked clickable while doing nothing, which is the worst combination.
//
// It opens the picker, because that is the only thing the calendar icon can
// sensibly mean, and it is what the icon already promised.
//
// WHY IT WALKS THE DOM RATHER THAN USING A REF
// These buttons live in ten places, several of them inside .map() over a
// filter list, so a ref would have to be an indexed array threaded through
// each one. The picker input is always the sibling inside the same
// .input-group, and react-flatpickr hangs its instance off the input element
// as `_flatpickr` - so one helper covers every copy with no plumbing, and a
// new filter row gets the behaviour for free.
export const openDateRangePicker = (event) => {
  // The click may land on the <i>; the input is a sibling of its parent.
  const group = event?.currentTarget?.closest?.(".input-group");
  const input = group?.querySelector("input");
  if (!input) return;

  // Normal path: ask flatpickr directly.
  if (input._flatpickr && typeof input._flatpickr.open === "function") {
    input._flatpickr.open();
    return;
  }

  // Fallback for any picker that is not flatpickr, or is not mounted yet.
  // clickOpens is on by default, so focus is enough to open it.
  input.focus();
};

export default openDateRangePicker;
